export default __webpack_public_path__ + "static/media/bti-dropdown.abe6761c.webp";